import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {NoteModel} from '../../../models/patient-file/patient-file.model';
import {MatTab, MatTabGroup} from '@angular/material/tabs';

@Component({
  selector: 'app-important-notes',
    imports: [
        MatTabGroup,
        MatTab
    ],
  templateUrl: './important-notes.component.html',
  styleUrl: './important-notes.component.sass'
})
export class ImportantNotesComponent {
    constructor(
        public dialogRef: MatDialogRef<ImportantNotesComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { notes: NoteModel[] }
    ) {
    }

    onClose(): void {
        this.dialogRef.close();
    }

    onSubmit(): void {
        this.dialogRef.close();
    }
}
